import { createContext, useContext } from "react";

export interface TickerContextValue {
  symbol: string | null;
}

export const TickerContext = createContext<TickerContextValue>({
  symbol: null,
});

/**
 * Hook to access the current ticker context.
 * Returns the ticker symbol if currently viewing a TickerDetail page.
 *
 * **IMPORTANT**: This context triggers automatic cache invalidation:
 *
 * 1. **JournalEditor (create/edit)**:
 *    - NEW journals: Only refreshes if journal mentions the current ticker
 *    - EDIT journals: Always refreshes (might be removing ticker mentions)
 *
 * 2. **useUpdateMemo (archive/pin/unpin)**:
 *    - Always refreshes when in TickerDetail page (affects list display)
 *
 * This ensures the "Associated Journals" list in TickerDetail stays in sync
 * while avoiding unnecessary API calls for unrelated journals.
 */
export const useTickerContext = () => useContext(TickerContext);
